import type { DataTableFilterMeta } from 'primereact/datatable';
import { dateTimeFilterToBounds } from './dateTimeFilter';
import { moscowCalendarToUtc, parseCalendarDay } from './dateTime';

/** Проверяет дату строки по календарному условию с исключительной верхней границей */
export const matchesDateTimeFilter = (value: unknown, filter: unknown): boolean => {
    const bounds = dateTimeFilterToBounds(filter);

    if (!bounds) return true;
    if (value === null || value === undefined || value === '') return false;

    const dateOnly = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
        ? parseCalendarDay(value)
        : null;

    const instant = dateOnly
        ? Date.parse(moscowCalendarToUtc(dateOnly, '00:00'))
        : value instanceof Date
            ? value.getTime()
            : typeof value === 'string'
                ? Date.parse(value)
                : Number.NaN;

    return Number.isFinite(instant)
        && (!bounds.from || instant >= Date.parse(bounds.from))
        && (!bounds.to || instant < Date.parse(bounds.to));
};

/** Оставляет обычные фильтры таблицы вне календарных колонок */
export const withoutDateTimeFilters = (
    filters: DataTableFilterMeta | undefined,
    dateFields: readonly string[],
): DataTableFilterMeta => Object.fromEntries(
    Object.entries(filters ?? {}).filter(([field]) => !dateFields.includes(field)),
);
